import { IconProps } from "../../../types/style";

const LogoutSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.19 2.5H7.81C4.17 2.5 2 4.67 2 8.31V16.69C2 19.5 3.29 21.43 5.56 22.16C6.22 22.39 6.98 22.5 7.81 22.5H16.19C17.02 22.5 17.78 22.39 18.44 22.16C20.71 21.43 22 19.5 22 16.69V8.31C22 4.67 19.83 2.5 16.19 2.5ZM20.5 16.69C20.5 18.83 19.66 20.18 17.97 20.74C17 18.83 14.7 17.47 12 17.47C9.3 17.47 7.01 18.82 6.03 20.74H6.02C4.35 20.2 3.5 18.84 3.5 16.7V8.31C3.5 5.49 4.99 4 7.81 4H16.19C19.01 4 20.5 5.49 20.5 8.31V16.69Z"
          fill={color}
        />
        <path
          d="M11.9999 8.5C10.0199 8.5 8.41992 10.1 8.41992 12.08C8.41992 14.06 10.0199 15.67 11.9999 15.67C13.9799 15.67 15.5799 14.06 15.5799 12.08C15.5799 10.1 13.9799 8.5 11.9999 8.5Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default LogoutSVG;
